module.exports = __webpack_public_path__ + "img/通知公告W.510c4087.svg";